// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-user-list-container-dialog .fi-user-list {
  background-color: unset;
  padding: 0;
}
.fi-user-list-container-dialog .fi-user-list .mat-mdc-card {
  padding: 0;
  box-shadow: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/user/fi-user-list-container-dialog/fi-user-list-container-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,uBAAA;EACA,UAAA;AAAR;AAEQ;EACI,UAAA;EACA,gBAAA;AAAZ","sourcesContent":[".fi-user-list-container-dialog {\r\n    .fi-user-list {\r\n        background-color: unset;\r\n        padding: 0;\r\n\r\n        .mat-mdc-card {\r\n            padding: 0;\r\n            box-shadow: none;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
